import onlineCourse from 'iztech-design-system-neo/dist/system/i18n/vi/onlineCourse'

const DETAIL = {
	MSG_NO_LESSON: 'Khóa học hiện chưa có bài giảng nào!',
}

export default {
  ...onlineCourse,
  DETAIL,
}